import { render } from "./formApply.vue?vue&type=template&id=3ff19504"
import script from "./formApply.vue?vue&type=script&lang=js"
export * from "./formApply.vue?vue&type=script&lang=js"

import "./formApply.vue?vue&type=style&index=0&id=3ff19504&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__